import React from "react";
import MaterialTableRtl from "../../UI/MaterialTableRtl/MaterialTableRtl";
import { client } from "../../../service/ApolloClient/ApolloClient";
import { QUERY_CHEQUES } from "../../../service/ApolloClient/ApolloQueries";
import {
  Box,
  IconButton,
} from "@material-ui/core";
import { ErrorToast } from "../../../hoc/ToastNotify/ToastNotify";
import calculateValueCheque from "../../../utility/CalculateValueCheque/calculateValueCheque";
import NumberFormat from "react-number-format";
import { AddOutlined, CheckCircleOutline } from "@material-ui/icons";
import checkDateInput from "../../../utility/CheckDateInput/checkDateInput";
import moment from "moment";

class ChequeContractStepList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      columns: [
        { title: "ID", field: "id" },
        { title: "شماره چک", field: "cheque_id" },
        {
          title: "صاحب چک",
          field: "first_party_fullname",
          render: (rowData) =>
            rowData.first_party_id ? (
              <a href={`/person/edit/${rowData.first_party_id}`}>
                {rowData.first_party_fullname}
              </a>
            ) : (
              "مشخص نشده"
            ),
        },
        {
          title: "دهنده",
          field: "giver_user_fullname",
          render: (rowData) =>
            rowData.giver_user_id ? (
              <a href={`/user/${rowData.giver_user_id}`}>
                {rowData.giver_user_fullname}
              </a>
            ) : (
              "مشخص نشده"
            ),
        },
        {
          title: "گیرنده",
          field: "reciver_user_fullname",
          render: (rowData) =>
            rowData.reciver_user_id ? (
              <a href={`/user/${rowData.reciver_user_id}`}>
                {rowData.reciver_user_fullname}
              </a>
            ) : (
              "مشخص نشده"
            ),
        },
        {
          title: "در وجه",
          field: "second_party_fullname",
          render: (rowData) =>
            rowData.second_party_id ? (
              <a href={`/user/${rowData.second_party_id}`}>
                {rowData.second_party_fullname}
              </a>
            ) : (
              "مشخص نشده"
            ),
        },
        {
          title: "مبلغ",
          field: "amount",
          render: (rowData) => (
            <NumberFormat
              value={rowData.amount}
              thousandSeparator={true}
              displayType={"text"}
            />
          ),
        },
        {
          title: "سررسید",
          field: "due_date",
          render: (rowData) => rowData.due_date_fa,
        },
        {
          title: "باقی مانده",
          field: "due_date",
          render: (rowData) => {
            let origin = moment(this.props.originDate);
            let due_date = moment(rowData.due_date);
            return due_date.diff(origin, "days");
          },
        },
        {
          title: "ارزش",
          field: "value",
          sorting: false,
          render: (rowData) => {
            let origin = moment(this.props.originDate);
            let due_date = moment(rowData.due_date);

            return (
              <NumberFormat
                value={calculateValueCheque(
                  this.props.percent,
                  rowData.amount,
                  parseInt(due_date.diff(origin, "days")),
                )}
                thousandSeparator={true}
                displayType={"text"}
              />
            );
          },
        },
        {
          title: "انتخاب",
          sorting: false,
          field: "id",
          render: (rowData) => {
            let ff = props.firstCheque.find((c) => c.id == rowData.id);

            return (
              <IconButton
                onClick={(e) => {
                  this.handleClickCheque(rowData);
                }}
              >
                {ff ? <CheckCircleOutline /> : <AddOutlined />}
              </IconButton>
            );
          },
        },
      ],
    };

    this.handleClickCheque = this.handleClickCheque.bind(this);
  }

  componentDidMount() {
    // this.fetchData();
  }

  remoteData = (query) => {
    return client
      .query({
        query: QUERY_CHEQUES,
        variables: {
          page: query.page + 1,
          limit: query.pageSize,
          search: query.search,
          orderBy: query.orderBy ? query.orderBy.field : null,
          orderDirection: query.orderDirection,
          percent: parseFloat(this.props.percent),
          maxAmount: parseInt(this.props.saghf),
          origin_date: checkDateInput(this.props.originDate),
          type: "reciver_user_id_now",
        },
        fetchPolicy: "network-only",
      })
      .then((res) => {
        let data = structuredClone(res.data);
        return {
          data: data.cheques.data,
          page: query.page,
          totalCount: data.cheques.total,
        };
      });
  };

  handleClickCheque = (cheque) => {
    let checkFind = this.props.firstCheque.find((che) => che.id == cheque.id);

    if (!checkFind) {
      this.props.setFirstCheque([...this.props.firstCheque, cheque]);
    } else {
      ErrorToast("قبلا انتخاب شده");
    }
  };

  render() {
    const { columns, data } = this.state;

    return (
      <Box>
        <MaterialTableRtl
          tableRef={this.props.tableRef}
          columns={columns}
          data={this.remoteData}
          needExport={true}
          title={"چک های که شما گرفته اید"}
          pdfName={"چک های که شما گرفته اید"}
        />
      </Box>
    );
  }
}

export default ChequeContractStepList;
